import React from 'react';
import PropTypes from 'prop-types';
import { is } from 'ramda';

import { view } from './DiagnosisText.less';

const DiagnosisText = ({ editing, input, localeMessage, hintLocale, formValues, ...other }) => (
  <div className={view}>{is(String, input.value) ? localeMessage('comorbidity.opts.' + input.value) : null}</div>
);

DiagnosisText.propTypes = {
  editing: PropTypes.bool.isRequired,
  input: PropTypes.object.isRequired,
  localeMessage: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  hintLocale: PropTypes.string,
};

export default DiagnosisText;
